/* ATTOLLE — fiche produit : coloris, packs, galerie, ajout au panier.

   Le prix affiché est toujours recalculé : prix de la variante choisie + prix
   des accessoires du pack. Rien n'est figé au rendu, sinon changer de coloris
   laisserait un prix périmé à l'écran.

   L'ajout au panier ouvre le tiroir latéral au lieu de rediriger vers /cart :
   une redirection sort l'acheteur de la fiche et casse l'ajout multiple. On
   demande à Shopify de renvoyer les sections concernées dans la même requête
   (paramètre "sections" de cart/add.js), ce qui évite un second aller-retour
   pour rafraîchir le tiroir et la pastille du panier. */
(function () {
  if (customElements.get('attolle-buy')) return;

  var LOCALE = (document.documentElement.lang || 'fr').slice(0, 2);

  function money(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    if (LOCALE === 'en') {
      return '€' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
    }
    return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + n[1] + ' €';
  }

  var track = document.getElementById('apdp-track');

  function slides() {
    return track ? Array.prototype.slice.call(track.children) : [];
  }

  /* Amene un visuel dans le rail, quel que soit le sens de défilement :
     horizontal en desktop, vertical en mobile. En desktop le rail est en
     overflow: hidden pour ne pas capter la molette (voir attolle-scroll) ;
     scrollTo continue d'y fonctionner. */
  function showSlide(el) {
    if (!track || !el) return;
    if (track.scrollWidth > track.clientWidth + 4) {
      track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    } else {
      el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  function markCurrent(index) {
    document.querySelectorAll('[data-thumb]').forEach(function (t, n) {
      t.setAttribute('aria-current', n === index ? 'true' : 'false');
    });
    document.querySelectorAll('.apdp__dot').forEach(function (d, n) {
      d.setAttribute('aria-current', n === index ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('[data-thumb]');
    if (!thumb) return;
    var i = Number(thumb.dataset.thumb);
    showSlide(slides()[i]);
    markCurrent(i);
  });

  if (track) {
    track.addEventListener('scroll', function () {
      var i = track.scrollWidth > track.clientWidth + 4
        ? Math.round(track.scrollLeft / track.clientWidth)
        : 0;
      markCurrent(i);
    }, { passive: true });
  }

  /* ---- Tiroir panier ---- */

  /* Les identifiants de section du thème sont générés : on les lit dans le DOM
     plutôt que de les coder en dur, sinon un renommage côté thème casse l'ajout
     au panier sans qu'on s'en aperçoive. */
  function sectionHosts() {
    var out = [];
    var drawer = document.getElementById('shopify-section-cart-drawer-section');
    if (drawer) out.push({ id: 'cart-drawer-section', el: drawer });
    var header = document.querySelector('[id^="shopify-section-sections--"][id$="__header_section"]');
    if (header) out.push({ id: header.id.replace('shopify-section-', ''), el: header });
    return out;
  }

  function applySections(hosts, sections) {
    if (!sections) return;
    hosts.forEach(function (h) {
      var markup = sections[h.id];
      if (!markup) return;
      var doc = new DOMParser().parseFromString(markup, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + h.id) || doc.body.firstElementChild;
      if (fresh) h.el.replaceWith(fresh);
    });
  }

  /* Horizon expose le panier latéral comme <theme-drawer id="cart-drawer">, avec
     open() / close() / toggle() — c'est ce que déclenche l'icône du panier dans
     l'en-tête (on:click="#cart-drawer/toggle"). On passe par la même porte.
     Le dialog-component n'est utilisé que par la recherche et l'ajout rapide. */
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    if (d && typeof d.toggle === 'function') { d.toggle(); return true; }
    var dlg = document.querySelector('cart-drawer-component dialog-component');
    if (dlg && typeof dlg.showDialog === 'function') { dlg.showDialog(); return true; }
    return false;
  }

  class AttolleBuy extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.btn = this.querySelector('[data-buy]');
      this.err = this.querySelector('[data-error]');
      this.variants = this.readVariants();

      this.form.addEventListener('submit', (e) => this.submit(e));
      this.addEventListener('change', () => this.sync());

      var sticky = document.querySelector('[data-sticky-buy]');
      if (sticky) sticky.addEventListener('click', () => this.submit());

      var bar = document.querySelector('[data-sticky]');
      if (bar && this.btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.setAttribute('data-visible', entries[0].isIntersecting ? 'false' : 'true');
        }, { rootMargin: '0px 0px -100% 0px' }).observe(this.btn);
      }

      this.sync();
    }

    readVariants() {
      var el = document.querySelector('[data-attolle-variants]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    get variant() {
      if (!this.variants) return null;
      var chosen = Array.prototype.map.call(
        document.querySelectorAll('[data-opt]:checked'),
        function (i) { return i.value; }
      );
      if (!chosen.length) return this.variants[0];
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return this.variants[0];
    }

    get tier() { return this.querySelector('input[name="ath-tier"]:checked'); }
    get basePrice() { var v = this.variant; return v ? v.price : Number(this.dataset.basePrice || 0); }
    get baseId() { var v = this.variant; return v ? v.id : Number(this.dataset.baseId || 0); }

    sync() {
      var base = this.basePrice;

      Array.prototype.forEach.call(this.querySelectorAll('input[name="ath-tier"]'), function (input) {
        var acc = Number(input.dataset.accTotal || 0);
        var row = input.closest('.apdp__tier');
        if (row) {
          var cell = row.querySelector('.apdp__tier-price');
          if (cell) cell.textContent = money(base + acc);
        }
      });

      var t = this.tier;
      var total = base + (t ? Number(t.dataset.accTotal || 0) : 0);
      document.querySelectorAll('[data-price-out]').forEach(function (el) {
        el.textContent = money(total);
      });

      var checked = document.querySelector('[data-opt]:checked');
      var label = document.querySelector('[data-opt-current]');
      if (checked && label) label.textContent = checked.value;

      var v = this.variant;
      if (v) {
        if (v.media) {
          var s = document.querySelector('[data-media-id="' + v.media + '"]');
          if (s) { showSlide(s); markCurrent(slides().indexOf(s)); }
        }
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
        if (this.btn) this.btn.disabled = !v.available;
      }
    }

    submit(e) {
      if (e) e.preventDefault();

      var baseId = this.baseId;
      if (!baseId) return;

      var t = this.tier;
      var accIds = [];
      if (t && t.dataset.accIds) {
        accIds = t.dataset.accIds.split(',').filter(Boolean)
          .map(Number).filter(function (n) { return n > 0; });
      }

      var titreEl = document.querySelector('.apdp__title');
      var titre = titreEl ? titreEl.textContent.replace(/\s+/g, ' ').trim() : '';

      /* Ordre et étiquetage des lignes du panier. 27/08/2026, demande du client :
         l'accessoire d'une configuration doit se voir dans le panier, sinon
         « je vais oublier de le commander ».

         Deux choses, donc :

         — les accessoires partent AVANT le produit. Shopify présente le panier du
           plus récent au plus ancien : envoyé en dernier, le produit principal se
           retrouve en tête et son accessoire juste dessous. Envoyé en premier, il
           se retrouvait sous l'adaptateur, ce qui donnait un panier où un câble à
           30 € ouvrait la liste devant un panneau à 279 €.

         — chaque accessoire porte une propriété de ligne « Ajouté avec » qui nomme
           le produit. Elle s'affiche dans le panier, au paiement et sur la
           commande : l'acheteur voit pourquoi cette ligne est là, et la personne
           qui prépare le colis sait que les deux vont ensemble.

         La propriété ne commence pas par un tiret bas : elle est donc visible.
         C'est voulu. */
      var items = accIds.map(function (id) {
        var ligne = { id: id, quantity: 1 };
        if (titre) ligne.properties = { 'Ajouté avec': titre };
        return ligne;
      });
      items.push({ id: baseId, quantity: 1 });

      var self = this;
      this.btn.setAttribute('aria-busy', 'true');
      if (this.err) this.err.hidden = true;

      var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
      var hosts = sectionHosts();

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: hosts.map(function (h) { return h.id; }).join(','),
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function (data) {
        self.btn.removeAttribute('aria-busy');
        applySections(hosts, data && data.sections);
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'attolle-buy' } }));
        /* Si le tiroir n'existe pas — thème sans panier latéral, ou script du
           thème non chargé — on retombe sur la page panier plutôt que de laisser
           l'acheteur sans retour visible. */
        if (!openDrawer()) window.location.href = self.dataset.redirect || '/cart';
      }).catch(function () {
        self.btn.removeAttribute('aria-busy');
        if (self.err) self.err.hidden = false;
      });
    }
  }
  customElements.define('attolle-buy', AttolleBuy);
})();
